import { createSlice } from "@reduxjs/toolkit"; 

export const Templates = createSlice({
    name: 'templates',
    initialState: {
        loaded: false,
        templates: [],
        selection: -1,
        request: {
            city: "",
            name: "",
            email: "",
            desireddate: null,
            sent: false
        }
    },
    reducers: {
        setTemplates(state, data) {
            state.templates = data.payload;
            state.loaded = true;
        },
        unloadTemplates(state) {
            state.loaded = false;
            state.templates = [];
            state.selection = -1;
            state.request = {
                city: "",
                name: "",
                email: "",
                desireddate: null,
                sent: false
            };
        },
        setSelection(state, s) {
            state.selection = parseInt(s.payload);
        },
        setCity(state, c) {
            state.request.city = c.payload;
        },
        setName(state, n) {
            state.request.name = n.payload;
        },
        setEmail(state, e) {
            state.request.email = e.payload;
        },
        setDesiredDate(state, d) {
            state.request.desireddate = new Date(d.payload);
        },
        setSent(state, b) {
            state.request.sent = b.payload;
        }
    }
});

export const { setTemplates, unloadTemplates, setSelection, setCity, setName, setEmail, setDesiredDate, setSent } = Templates.actions;

export default Templates.reducer;